import * as React from 'react'
import { Site } from '@envato/foundation-types'

import FullWidthBannerBlock from '../../../components/categoryPage/fullWidthBannerBlock'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { ICommonLocation } from '../../../../common/utils/location/types'

import * as styles from './fullWidthBannerSection.module.css'

// leaving this here as reference for the data shape
const fullWidthBannerData: any = {
  site_goes_here: {
    title: '40% off 900+ themes & web templates',
    subtitle: 'Save on best-selling WordPress themes, HTML templates & more!',
    buttonText: 'Go to sale',
    backgroundColor: '#99DBDC',
    textColor: '#191919',
    url:
      'https://themeforest.net/search?discount_type=envato&discounted_only=1',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-banner-march-2021-tf.jpg',
      alt: 'March Sale 2021'
    },
    gaLabel: 'march_sale_2021'
  }
}

const FullWidthBannerSection = ({
  makeSearchLink,
  currentSite,
  location,
  bgColor
}: {
  currentSite: Site
  location: ICommonLocation
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  bgColor: string
}) => {
  if (!fullWidthBannerData[currentSite]) {
    return null
  }
  return (
    <section
      className={styles.fullWidthBannerSectionWrapper}
      style={{ background: bgColor }}
    >
      <div className={styles.fullWidthBannerWrapper}>
        <FullWidthBannerBlock
          location={location}
          locationParams={{}}
          componentType="FullWidthBannerBlock"
          makeSearchLink={makeSearchLink}
          currentSite={currentSite}
          data={fullWidthBannerData[currentSite]}
        />
      </div>
    </section>
  )
}

export default FullWidthBannerSection
